var current,image,imgObj,imgSource,reader,file,text = "Enter Your Text",id,
    canvas,canvas1,imgData,imgWidth,alignment,activeOb,target,fontSize,object,type,sCAle,
    textInput = document.getElementById('text_box'),effect,
    fill,fSize,fStyle,fWeight,tAlign,shade,f,action,left,top,oX,oY,sX,sY,
    undoButton = document.getElementById('undo'),
    redoButton = document.getElementById('redo'),
    Family = document.getElementById('fontFamily').value,
    bold = document.getElementById('bold'),
    italic = document.getElementById('italic'),
    cHeight = window.innerHeight * 0.50,
    cWidth = cHeight * 1.96;
var filters = ['grayscale', 'invert', 'remove-color', 'sepia', 'brownie',
               'brightness', 'contrast', 'vintage', 'technicolor', 'polaroid',
               'kodachrome', 'blackwhite'];

var diameter = +$('#diameter').val();
var kerning = +$('#kerning').val();
var flipped = $('#flip').is(':checked');


const baseDims = {
  top:   { width: 532, height: 271 },
  sid:  { width: 532, height: 345 },
  frt: { width: 532, height: 162 }
};

// Default Desktop Base Reference
let mainWide = 956;
let mainHigh = 487;

// === Calculate Responsive Size Based on Screen ===
function getResponsiveCanvasSize(side) {
  const dim = baseDims[side] || baseDims.top;
  const screenW = window.innerWidth;

  let scaleFactor = 1;
  if (screenW <= 600) scaleFactor = 0.55;     // mobile
  else if (screenW <= 992) scaleFactor = 0.75; // tablet

  return {
    width: dim.width * scaleFactor,
    height: dim.height * scaleFactor
  };
}

// === Store All Canvases Globally ===
window.canvases = {};



function addGuideBox(canvas, name) {
  if (name !== 'top') return; // only for top canvas

  const { width, height } = getCanvasSize(canvas);
  const zoom = canvas.getZoom();
  // create dashed rectangle (slightly inset from edges)
  const guide = new fabric.Rect({
    left: 266,
    top: 135.5,
    originX: 'center',
    originY: 'center',
    width: width * 0.75,  // adjust size as needed
    height: height * 0.38,
    stroke: '#888',
    strokeWidth: 1,
    strokeDashArray: [5, 5],
    fill: 'transparent',
    selectable: false,
    evented: false,
    excludeFromExport: true, // will NOT appear in printable export
  });

  // tag it so we can remove later if needed
  guide.name = 'guideBox';
  canvas.add(guide);
  canvas.sendToBack(guide);
  canvas.renderAll();
}




// === Initialize Each Canvas ===
Object.keys(baseDims).forEach(name => {
  const size = getResponsiveCanvasSize(name);
  const canvasEl = document.getElementById(`${name}Canvas`);
  if (!canvasEl) return;

  const c = new fabric.Canvas(canvasEl, {
    width: size.width,
    height: size.height,
    backgroundColor: "rgba(0,0,0,0.05)",
    selection: true,
    preserveObjectStacking: true,
  });

  window.canvases[name] = c;
  window[name + 'Canvas'] = c;

    addGuideBox(c, name);

  if (typeof addModify === "function") addModify(c, name); // ✅ pass name
  if (window.drawHistory && typeof drawHistory.initCanvasState === "function") {
    drawHistory.initCanvasState(name);
  }

  c.renderAll();
});

function getActiveCanvas() {
  const activeSide = $(".sideBtns>.button.active").data("side");
  return window.canvases[activeSide] || null;
}

function getCanvasSize(canvas) {
  return { width: canvas.width, height: canvas.height };
}


$(document).on("click", ".sideBtns>.button", function () {
  const $btn = $(this);
  var name = $btn.attr('data-side');
  const targetSide = $btn.data("side"); // top | side | front

  $(".sideBtns>.button").removeClass("active");
  $(".side").removeClass("active");

  $btn.addClass("active");
  $("#" + targetSide + "Section").addClass("active");

  const canvas = window.canvases[targetSide];
  if (canvas instanceof fabric.Canvas) {
    canvas.discardActiveObject();
    canvas.renderAll();
    canvasBlock(canvas,name);
    if (typeof updatedPreivew === "function") updatedPreivew(canvas);
  }
});


// ON LOAD
jQuery(window).on('load', function(){
    var id = jQuery('.side.active').find('canvas').attr('id');
    var name = jQuery('.sideBtns .button.active').attr('data-side');
    var canvas = window[id];
    canvasBlock(canvas,name);
    jQuery('#loader').hide();
});

// ON RESIZE
jQuery(window).resize(function(){
    var id = jQuery('.side.active').find('canvas').attr('id');
    var name = jQuery('.sideBtns .button.active').attr('data-side');
    var canvas = window[id];
    canvasBlock(canvas,name);
});

tooltip();
jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});

var shirtColorListName = ['Black', 'White'];
var shirtColorListCode = [
  '#08090d', // Black
  '#e7e9ed' // White
  ];

jQuery(document).on('click','.drawingButton .main_buttons',function(){
  id = jQuery('.side.active').find('.lower-canvas').attr('id');
  var name = jQuery('.sideBtns .button.active').attr('data-side');
  canvas = window[id];

  var selectedColor = jQuery('input[name="Color"]:checked').val();
  var index = shirtColorListName.indexOf(selectedColor);
  
  if (index !== -1) {
      var colorCode = shirtColorListCode[index];
    window['topCanvas'].setBackgroundColor(colorCode, window['topCanvas'].renderAll.bind(window['topCanvas']));
    window['sidCanvas'].setBackgroundColor(colorCode, window['sidCanvas'].renderAll.bind(window['sidCanvas']));
    window['frtCanvas'].setBackgroundColor(colorCode, window['frtCanvas'].renderAll.bind(window['frtCanvas']));
  } else {
  }
  
  canvasBlock(canvas,name);

  jQuery('.popupImg').attr('style','visibility:visible');
  jQuery('#tadaWidget').hide();
});
let sideCheck = 0;
jQuery(document).on('click','.tool_option>.closePreview',function(){
  id = jQuery('.side.active').find('.lower-canvas').attr('id');
  canvas = window[id];
  sideCheck = 0;
  window['topCanvas'].setBackgroundColor(null, window['topCanvas'].renderAll.bind(window['topCanvas']));
  window['sidCanvas'].setBackgroundColor(null, window['sidCanvas'].renderAll.bind(window['sidCanvas']));
  window['frtCanvas'].setBackgroundColor(null, window['frtCanvas'].renderAll.bind(window['frtCanvas']));
  canvas.discardActiveObject().renderAll();

  updatedPreivew(window['topCanvas']);
  updatedPreivew(window['sidCanvas']);
  updatedPreivew(window['frtCanvas']);
  
  if(sideCheck < 2){
    jQuery('input[name="Sides"][value="Single Side"]').prop('checked',true).change();
  }else if(sideCheck < 3  ){
    jQuery('input[name="Sides"][value="Double Sides"]').prop('checked',true).change();
  }else{
    jQuery('input[name="Sides"][value="Triple Sides"]').prop('checked',true).change();
  }
  console.log('Currently '+sideCheck+' Sides');

  jQuery('.popupImg').attr('style','visibility:hidden');
});

jQuery('.popupBox').each(function(){
  jQuery(this).draggable({
    start: function() {
      /*jQuery(this).css('position','');
      jQuery(this).css('right','');*/
    },
    handle: "div.drag-me"
  });
});

jQuery('.popupBox input,.popupBox select,.popupBox textarea,.colorpicker,.colorpicker *').on('mousedown touchstart', function(e){
  e.stopPropagation();
});

jQuery(document).on('click','.tool_option>h4',function(){
  current = jQuery(this).next();
  jQuery('.popupBox').each(function(){
    jQuery(this).hide();
  });
  current.show();
  if(jQuery(window).width() < '767'){
    jQuery('#cImagePop').css({
      'top': '-410px',
      'left': '98px'
    });
  }
});

jQuery(document).on('click','.closeTpop',function(e){
  e.stopPropagation();
  id = jQuery('.side.active').find('.lower-canvas').attr('id');
  canvas = window[id];
  jQuery(this).parent().hide();
  canvas.discardActiveObject().renderAll();
});

jQuery(document).on('change','#uploadFile',function(event){
  file = event.target.files[0];
  reader = new FileReader();
  reader.onloadend = function(){
    imgSource = reader.result;
  };
  reader.readAsDataURL(file);
});

jQuery(document).on('change','#terms',function(){
  var term = jQuery(this).prop('checked');
  if(term){
    jQuery('#uploadNow').removeAttr('disabled');
  }else{
    jQuery('#uploadNow').attr('disabled','disabled');
  }
});

jQuery(document).on('click','#uploadNow',function(){
  id = jQuery('.side.active').find('.lower-canvas').attr('id');
  canvas = window[id];
  reader = new FileReader();
  const zoom = canvas.getZoom();
  reader.onload = function (event){
    imgObj = new Image();
    imgObj.src = imgSource;
    imgObj.onload = function(){
      image = new fabric.Image(imgObj);
      image.set({
          originX:"center",
          originY:"center",
          scaleX: 1,
          scaleY: 1,
          left: (canvas.getWidth() / 2) / zoom,
          top: (canvas.getHeight() / 2) / zoom
      });
      image.scaleToWidth(cWidth/2);
      canvas.add(image).setActiveObject(image);
      canvas.renderAll();
    }
  }
  reader.readAsDataURL(file);
  jQuery('#uploadFile').val('');
  jQuery('#terms').prop('checked',false);
});

jQuery(document).on('click','#changeText',function(){
  id = jQuery('.side.active').find('.lower-canvas').attr('id');
  canvas = window[id];
  addText(canvas);
});

jQuery(document).on('change','#clipart_category',function(){
  Showcontainer();
});

function tooltip(){
  var tipContent;
  jQuery('.toolTip').each(function(){
    tipContent = jQuery(this).attr('tooltip');
    jQuery(this).after('<div class="tooltipLabel">'+tipContent+'</div>');
  });
}
  
function Showcontainer(){
  var selectedOption = document.getElementById("clipart_category").value;
  jQuery('.drop_down_catgory>div').each(function(){
    jQuery(this).hide();
  });
  document.getElementById(selectedOption).style.display = "block";
}

var clonedObject = _.cloneDeep(object);
function cloneFabricObject(object) {
  return fabric.util.object.clone(object);
}

jQuery(document).on('click','.actionBtns>a',function(){
  if(jQuery(this).parent().hasClass('disabled')){
    return false
  }
  action = jQuery(this).attr('data-obj');
  activeOb = canvas.getActiveObject();
  const zoom = canvas.getZoom();
  if(activeOb){
    if(action === 'front'){
      canvas.bringToFront(activeOb);
    }
    if(action === 'flip'){
      activeOb.toggle('flipX');
    }if(action === 'alignH'){
      activeOb.left = (canvas.getWidth() / 2) / zoom;
    }if(action === 'alignV'){
      activeOb.top = (canvas.getHeight() / 2) / zoom;
    }if(action === 'moveL'){
      activeOb.left -= 2;
    }if(action === 'moveR'){
      activeOb.left += 2;
    }if(action === 'moveT'){
      activeOb.top -= 2;
    }if(action === 'moveB'){
      activeOb.top += 2;
    }if(action === 'trash'){
      canvas.remove(activeOb);
    }if(action === 'copy'){
      /*
      var cObject = fabric.util.object.clone(activeOb);
      canvas.add(cObject);
      canvas.setActiveObject(cObject);
      cObject.set('top', cObject.top+15);
      cObject.set('left', cObject.left+15);
      cObject.setCoords();
      */
      var clonedObject = cloneFabricObject(activeOb);
      canvas.discardActiveObject().renderAll();
      clonedObject.set({
        left: clonedObject.left + 15,
        top: clonedObject.top + 15
      });
      canvas.add(clonedObject).setActiveObject(clonedObject);
    }
    activeOb.setCoords();
    drawHistory.updateCanvasState(canvas,id);
  }
  canvas.renderAll();
});

function canvasMakeImg(canvas,zoom,name){
  const baseWidth = baseDims[name]?.width;
  newZoomLevel = zoom / baseWidth;
  setZoomMask(canvas,newZoomLevel,name);
}

function canvasBlock(canvas,name) {
  var checkSi = parseInt(jQuery('.sideBtns').innerWidth()) - 30;
  newZoomLevel = checkSi / baseDims[name]?.width;
  setZoomMask(canvas, newZoomLevel, name);
}


function showCanvas(sideName) {
  document.querySelectorAll('.side').forEach(div => div.classList.remove('active'));
  document.getElementById(sideName + 'Section').classList.add('active');

  const activeCanvas = window.canvases[sideName];
  if (activeCanvas) {
    canvasBlock(activeCanvas,sideName);
    activeCanvas.renderAll();
    updatedPreivew(activeCanvas);
  }
}

document.getElementById('topButton')?.addEventListener('click', () => showCanvas('top'));
document.getElementById('sidButton')?.addEventListener('click', () => showCanvas('sid'));
document.getElementById('frtButton')?.addEventListener('click', () => showCanvas('frt'));

// === Auto Adjust on Window Resize ===
/*window.addEventListener('resize', () => {
  const active = document.querySelector('.side.active');
  if (active) {
    const sideName = active.id.replace('Section', '');
    canvasBlock(window.canvases[sideName],);
  }
});*/


function setZoomMask(canvas, newZoomLevel, name) {
  const baseWidth = baseDims[name]?.width;
  const baseHeight = baseDims[name]?.height;
  console.log(baseHeight);
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width: baseWidth * newZoomLevel,
    height: baseHeight * newZoomLevel
  });
  canvas.renderAll();
  updatedPreivew(canvas);
}


function centerObjectOnActiveCanvas(obj) {
  const canvas = getActiveCanvas();
  if (!canvas || !obj) return;

  const { width, height } = getCanvasSize(canvas);
  obj.set({
    left: width / 2,
    top: height / 2,
    originX: "center",
    originY: "center",
  });

  canvas.add(obj);
  canvas.setActiveObject(obj);
  canvas.renderAll();
  if (typeof updatedPreivew === "function") updatedPreivew(canvas);
}


function addImageToActiveCanvas(imgURL) {
  const canvas = getActiveCanvas();
  if (!canvas) return;

  fabric.Image.fromURL(imgURL, function (img) {
    const { width } = getCanvasSize(canvas);
    img.scaleToWidth(width / 2);
    centerObjectOnActiveCanvas(img);
  });
}

$(document).ready(function () {
  $(".sideBtns>.button[data-side='top']").addClass("active");
  $("#topSection").addClass("active");

  const canvas = window.canvases.top;
  if (canvas instanceof fabric.Canvas) {
    canvas.renderAll();
    canvasBlock(canvas,'top');
    if (typeof updatedPreivew === "function") updatedPreivew(canvas);
  }
});


function updatedPreivew(canvas) {
  if (!canvas) return;
  const id = canvas.lowerCanvasEl.id;
  const objects = canvas.getObjects();


  // Change button text
  jQuery('.main_buttons').text(objects.length > 0 ? 'Customize Design' : 'Edit Design');

  if(objects.length > 0){
    sideCheck += 1;
  }

  const imgData = canvas.toDataURL("image/png");

  // Update the active preview
  // FIX: was '#id' (ID selector) which only ever updates the FIRST matching
  // element in the DOM (e.g. only the White variant's slide), leaving every
  // other variant's / mobile duplicate gallery's preview image blank.
  // Preview <img> elements now carry unique IDs but share these classes, so a
  // class selector correctly updates every instance (all variants + mobile).
  jQuery(`.${id}Preview`).attr('src', imgData);

  // Update all three previews (top/side/front) across every variant slide
  Object.entries(window.canvases).forEach(([sideName, c]) => {
    const previewClass = `${sideName}CanvasPreview`;
    const data = c.toDataURL("image/png");
    jQuery(`.${previewClass}`).attr('src', data);
  });
}


function updatedPreviewAll(canvas) {
  const imgData = canvas.toDataURL("image/png");
  const id = canvas.lowerCanvasEl.id;

  // Update preview for current canvas on EVERY variant slide (class selector
  // already matched all instances here — this part was fine).
  jQuery('.' + id + 'Preview').attr('src', imgData);

  // NOTE: width used to be force-set here via inline px (calculated once,
  // from a single ID-matched element, at whatever zoom level happened to be
  // active at that moment). That's what caused the overlay to only look
  // aligned at one specific browser zoom % and drift at every other zoom.
  // The CSS (.tissue_stickerTop/Side/Front) already sizes these images
  // responsively with 'width: ...% !important', so no JS width override is
  // needed or safe to keep.
}



function renderIcon(icon){
  return function (ctx, left, top, styleOverride, fabricObject){
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

var filteringBox = document.getElementById('imgFilterPop');

function addModify(canvas, sideName) {
  if (!(canvas instanceof fabric.Canvas)) {
    console.error("addModify: Not a fabric canvas object");
    return;
  }

  // Fabric setup
  fabric.Object.prototype.padding = 5;
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;
  canvas.renderOnAddRemove = false;

  // --- SELECTION CLEARED ---
  canvas.on("selection:cleared", function () {
    jQuery(".actionBtns").addClass("disabled");
    fabric.util.toArray(filteringBox.getElementsByTagName("input")).forEach(function (el) {
      el.disabled = true;
    });
    jQuery(".thePop").each(function () {
      jQuery(this).find(".colorOFF").trigger("click");
      jQuery(this).hide();
    });
  });

  // --- OBJECT SELECT EVENTS ---
  canvas.on("selection:created", function () {
    const object = canvas.getActiveObject();
    selectedObj(object);
  });

  canvas.on("selection:updated", function () {
    const object = canvas.getActiveObject();
    selectedObj(object);
  });

  // --- OBJECT SCALING ---
  canvas.on("object:scaling", function () {
    canvas.renderAll();
  });

  // --- OBJECT ADDED / MODIFIED ---
  canvas.on("object:added", function (e) {
    const object = e.target;
    if (window.drawHistory && typeof drawHistory.updateCanvasState === "function") {
      drawHistory.updateCanvasState(canvas, sideName);
    }
    if (typeof undoButton !== "undefined" && undoButton) {
      undoButton.removeAttribute("disabled");
    }
    if (typeof addControls === "function") {
      addControls(object);
    }
    updatedPreviewAll(canvas); // ✅ Update all previews
    canvas.renderAll();
  });

  canvas.on("object:modified", function (e) {
    if (window.drawHistory && typeof drawHistory.updateCanvasState === "function") {
      drawHistory.updateCanvasState(canvas, sideName);
    }
    updatedPreviewAll(canvas); // ✅ Update all previews
    canvas.renderAll();
  });

  // --- OBJECT REMOVED ---
  canvas.on("object:removed", function (e) {
    if (window.drawHistory && typeof drawHistory.updateCanvasState === "function") {
      drawHistory.updateCanvasState(canvas, sideName);
    }
    updatedPreviewAll(canvas); // ✅ Update all previews
    canvas.renderAll();
  });
}


function getActiveCanvasInfo() {
  const activeSection = document.querySelector(".side.active");
  if (!activeSection) return null;

  const activeCanvas = activeSection.querySelector("canvas");
  if (!activeCanvas) return null;

  const id = activeCanvas.id.replace("Canvas", ""); // e.g. "top", "side", "front"
  const canvas = window.canvases[id];
  return { canvas, id };
}

drawHistory.undoButton.addEventListener("click", function () {
  const active = getActiveCanvasInfo();
  if (active) drawHistory.undo(active.canvas, active.id);
});

drawHistory.redoButton.addEventListener("click", function () {
  const active = getActiveCanvasInfo();
  if (active) drawHistory.redo(active.canvas, active.id);
});



function selectedObj(object){
  jQuery('.thePop').each(function(){
    jQuery(this).hide();
  });
  jQuery('.actionBtns').removeClass('disabled');
  type = object.type;
  if(type == 'text'){
    jQuery('#italic').prop('checked',false);
    jQuery('#bold').prop('checked',false);

    
    fill = object.fill;
    Family = object.fontFamily;
    fSize = object.fontSize;
    fStyle = object.fontStyle;
    fWeight = object.fontWeight;
    text = object.text;
    tAlign = object.textAlign;

    jQuery('#textColor .currentColor').val(fill);
    jQuery('#textColor .currentColor+.colorBox').css('backgroundColor',fill);
    jQuery('#fontFamily').val(Family);
    jQuery('#fSize').val(fSize);
    jQuery('input[name="text-align"][value="'+tAlign+'"]').prop('checked',true);
    
    if(fStyle == 'italic'){
      jQuery('#italic').prop('checked',true);
    }
    if(fWeight == 'bold'){
      jQuery('#bold').prop('checked',true);
    }
    
    textInput.value = text;
    
    jQuery('#textPop').show();
  }
  if(type == 'path'){
    var isColor = /[0-9A-Fa-f]{6}/g;
    fill = object.stroke;
    shade = object.shadow.color;
    if(isColor.test(fill)){
      jQuery('#line-color .currentColor').val(fill);
      jQuery('#line-color .currentColor+.colorBox').css('backgroundColor',fill);
      jQuery('#shade-color .currentColor').val(shade);
      jQuery('#shade-color .currentColor+.colorBox').css('backgroundColor',shade);
      jQuery('#drawing-colors').show();
    }
  }
  if(type == 'image'){
    fabric.textureSize = 75497472;
    fabric.util.toArray(filteringBox.getElementsByTagName('input')).forEach(function(el){
      el.disabled = false;
    });
    for (var i = 0; i < filters.length; i++) {
      if($(filters[i]) && ($(filters[i]).checked = !!object.filters[i])){
        $('#'+filters[i]).prop('checked',true);
      }else{
        $('#'+filters[i]).prop('checked',false);
      }
      console.log($(filters[i]) && ($(filters[i]).checked = !!object.filters[i]));
    };
    jQuery('#imgFilterPop').show();
  }
  //console.log(object);
}

jQuery(document).on('change','#effect',function(){
  id = jQuery('.side.active').find('.lower-canvas').attr('id');
  canvas = window[id];
  effect = jQuery(this).val();
  object = canvas.getActiveObject();
  
  fill = object.fill;
  Family = object.fontFamily;
  fSize = object.fontSize;
  fStyle = object.fontStyle;
  fWeight = object.fontWeight;
  text = object.text;
  left = object.top;
  top = object.left;
  oX = object.originX;
  oY = object.originY;
  sX = object.scaleX;
  sY = object.scaleY;
  
  if(effect == 'curved'){
    const zoom = canvas.getZoom();
    const curvedText = new fabric.CurvedText(text, {
      left: (canvas.getWidth() / 2) / zoom,
      top: (canvas.getHeight() / 2) / zoom,
      fill: fill,
      fontFamily: Family,
      fontSize: fSize,
      fontStyle: fStyle,
      fontWeight: fWeight,
      originX: oX,
      originY: oY,
      radius: 150,
      startAngle: -90,
      spacing: 15,
      clockwise: true,
    });
    canvas.add(curvedText).setActiveObject(curvedText).renderAll();
  }
});

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}
  
function addText(canvas,name){
  const zoom = canvas.getZoom();
  var textObject = new fabric.Text('Enter Your Text',{
    left: (canvas.getWidth() / 2) / zoom,
    top: (canvas.getHeight() / 2) / zoom,
    originX:"center",
    originY:"center",
    scaleX: 1,
    scaleY: 1,
    fill: '#000',
    fontSize: 20,
    fontFamily: "'Arial',sans-serif",
    fontWeight: 'normal',
    textAlign: 'center'
  });
  canvas.add(textObject).setActiveObject(textObject).renderAll();
}

textInput.addEventListener('input', function(){
  id = jQuery('.side.active').find('.lower-canvas').attr('id');
  canvas = window[id];
  activeOb = canvas.getActiveObject();
  
  if(activeOb && activeOb.type === 'text'){
    activeOb.set({ text: this.value });
    canvas.renderAll();
    drawHistory.updateCanvasState(canvas,id);
  }
});

bold.addEventListener('change',function(){
  dtEditText('bold');
});

italic.addEventListener('change',function(){
  dtEditText('italic');
});

function dtEditText(action){
  id = jQuery('.side.active').find('.lower-canvas').attr('id');
  canvas = window[id];
  var o,t,
      a = action;
  o = canvas.getActiveObject();
  sCAle = o.scaleX;
  if(o){
    t = o.get('type');
  }
  if(o && t === 'text' || t === 'text-curved' || type === 'curvedText'){
    switch(a){
      case 'bold':
        var isBold = dtGetStyle(o, 'fontWeight') === 'bold';
        dtSetStyle(o, 'fontWeight', isBold ? '' : 'bold');
        break;
        
      case 'italic':
        var isItalic = dtGetStyle(o, 'fontStyle') === 'italic';
        dtSetStyle(o, 'fontStyle', isItalic ? '' : 'italic');
        break;
    }
  }
  o.scaleX = .5;
  o.setCoords();
  canvas.renderAll();
  o.scaleX = sCAle;
  o.setCoords();
  canvas.renderAll();
  drawHistory.updateCanvasState(canvas,id);
}

function dtGetStyle(object,styleName){
  return object[styleName];
}

function dtSetStyle(object,styleName,value){
  object.set(styleName,value);
}

function loadColorPicker(colorBox){
  jQuery('#'+colorBox).colorpicker({
    inline: true,
    container: true,
    extensions:[{
      name: 'swatches',
      options:{
        colors:{
          'tetrad1': 'transparent',
          'tetrad2': '#e30405',
          'tetrad3': '#197b30',
          'tetrad4': '#0054a5',
          'tetrad5': '#ffcc00',
          'tetrad6': '#f6ebbe',
          'tetrad7': '#ffea00',
          'tetrad8': '#f8931d',
          'tetrad9': '#f499c2',
          'tetrad10': '#959595',
          'tetrad11': '#fef335',
          'tetrad12': '#a0400d',
          'tetrad13': '#000000',
          'tetrad14': '#604973',
          'tetrad15': '#afe8fc',
          'tetrad16': '#fffafa',
          'tetrad17': '#bc8cbe',
          'tetrad18': '#ff69b4',
          'tetrad19': '#93278f',
          'tetrad20': '#009987',
          'tetrad21': '#0af447',
          'tetrad22': '#00008b',
          'tetrad23': '#006400'
        },
        namesAsValues: false
      }
    }],
    template: '<div class="colorpicker">' +
      '<div class="colorpicker-saturation"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-hue"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-alpha">' +
      '   <div class="colorpicker-alpha-color"></div>' +
      '   <i class="colorpicker-guide"></i>' +
      '</div>' +
      '<div class="colorpicker-bar">' +
      '   <a href="javascript:void(0);" class="button btn-block colorOFF">Ok</a>'+
      '   <div class="ctn-icon-eyedropper dropper-eyedrop"><svg class="icon icon-eyedropper" viewBox="0 0 16 16">'+
      '   <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5'+
      '   0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207'+
      '   1.207 0 0 0 0-1.708zM2 12.707l7-7L10.293 7l-7 7H2z"/></svg></div>'+
      '</div>' +
      '</div>'
  }).on('colorpickerCreate', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('id'),
        active = colorBox.find('.currentColor'),
        activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
    },200);
  }).on('colorpickerChange', function(){
    id = jQuery('.side.active').find('.lower-canvas').attr('id');
    canvas = window[id];
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('id'),
        active = colorBox.find('.currentColor'),
        activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
      colorBox.attr('data-color',activeCOLOR);
      updateBrush(canvas);
      activeOb = canvas.getActiveObject();
          if(activeOb){
            sCAle = activeOb.scaleX;
            if(colorID === 'textColor'){
              activeOb.set('fill',activeCOLOR);
            }
            if(colorID === 'line-color'){
                activeOb.stroke = activeCOLOR;
            }
            if(colorID === 'shade-color'){
              activeOb.shadow.color = activeCOLOR;
            }
            activeOb.scaleX = .5;
            activeOb.setCoords();
            canvas.renderAll();
            activeOb.scaleX = sCAle;
            activeOb.setCoords();
            canvas.renderAll();
            drawHistory.updateCanvasState(canvas,id);
        }
    },200);
  });
  jQuery(document).on('click','.colorBox',function(){
    jQuery('.colorBox').each(function(){
      jQuery(this).next().hide();
    });
    jQuery(this).next().show();
  });
  jQuery(document).on('click','.colorOFF',function(){
    var parENt = jQuery(this).parent().parent(),
        toolBarBox = parENt.parent().parent().parent().attr('id');
    if(toolBarBox === 'labelBase'){
      parENt.parent().parent().parent().parent().removeClass('active');
    }else{
      parENt.hide();
    }
  });
}

jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});

document.getElementById('fontFamily').addEventListener('change', function(){
  id = jQuery('.side.active').find('.lower-canvas').attr('id');
  canvas = window[id];
  activeOb = canvas.getActiveObject();
  if (activeOb && activeOb.type === 'text'){
    activeOb.set({ fontFamily: this.value });
    canvas.renderAll();
    drawHistory.updateCanvasState(canvas,id);
  }
});

jQuery(document).on('change','#fSize',function(){
  id = jQuery('.side.active').find('.lower-canvas').attr('id');
  canvas = window[id];
  fontSize = jQuery(this).val();
  activeOb = canvas.getActiveObject();
  if(activeOb){
    sCAle = activeOb.scaleX;
    type = activeOb.get('type');
    if(type === 'text' || type === 'curvedText'){
      activeOb.set('fontSize',fontSize);
    }
    activeOb.scaleX = .5;
    activeOb.setCoords();
    canvas.renderAll();
    activeOb.scaleX = sCAle;
    activeOb.setCoords();
    canvas.renderAll();
    drawHistory.updateCanvasState(canvas,id);
  }
});

jQuery(document).on('change','input[name="text-align"]',function(){
  id = jQuery('.side.active').find('.lower-canvas').attr('id');
  canvas = window[id];
  alignment = jQuery(this).val();
  activeOb = canvas.getActiveObject();
  if(activeOb){
    type = activeOb.get('type');
    if(type === 'text' || type === 'curvedText'){
      activeOb.set('textAlign',alignment);
    }
    activeOb.setCoords();
    canvas.renderAll();
    drawHistory.updateCanvasState(canvas,id);
  }
});

jQuery(document).on('click','.side-02 .popupBox .drop_down_catgory img',function(){
  current = jQuery(this);
  addImageToCanvas(current);
});

function addImageToCanvas(clickedImage){
  id = jQuery('.side.active').find('.lower-canvas').attr('id');
  canvas = window[id];
  var imgSrc = clickedImage.attr('data-src');
  const zoom = canvas.getZoom();
  imgObj = new Image();
  imgObj.src = imgSrc;
  imgObj.onload = function(){
    image = new fabric.Image(imgObj);
    image.set({
        originX:"center",
        originY:"center",
        scaleX: 1,
        scaleY: 1,
        left: (canvas.getWidth() / 2) / zoom,
    top: (canvas.getHeight() / 2) / zoom
    });
    image.scaleToWidth(cWidth/2);
    canvas.add(image).setActiveObject(image);
    canvas.renderAll();
  }
}

function deleteHandler(eventData,transform){
  id = jQuery('.side.active').find('.lower-canvas').attr('id');
  canvas = window[id];
  var target = transform.target;
  activeOb = canvas.getActiveObject();
  canvas.remove(activeOb);
  canvas.renderAll();
}
  
jQuery(document).on('click','#addThumb',function(){
  var size = 2000;//jQuery('.product__media-outer').innerWidth('4000');
  jQuery('#loader').show();
   canvasMakeImg(canvas,size,name);
  jQuery('.canvas_div').hide();
  imgData = canvas.toDataURL("image/png");
  fetch('//technology-architects.com/tasweer-modules/save_image.php',{
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      imageData: imgData
    })
  })
  .then(response => response.text())
  .then(data => {
    console.log(data);
    // FIX: this used to force every ".product__media-outer" (the overlay box
    // that sits on top of the White AND Black product photos, on both
    // desktop and mobile) to a hardcoded 248px width. That permanently broke
    // the container's CSS full-stretch positioning (left:0;right:0;top:0;
    // bottom:0), so the overlay only lined up with the box photo at the one
    // screen/zoom size where 248px happened to be roughly correct, and drifted
    // at every other zoom level. The container is already sized responsively
    // by CSS, so no JS width override is needed here.

    jQuery('#previewImg').val(data);
    jQuery('.product-form__buttons .product-form__submit').trigger('click');
    
    canvasBlock(canvas,name);
    jQuery('.canvas_div').show();
    jQuery('#loader').hide();
  })
  .catch(error => console.error('Error uploading images:', error));
});

var optS,optD,options,sides = 0;
var temp = 250, orig = 2000;

jQuery(document).on('click','#addT_Shirt',function(){
  jQuery('#loader').show();
  jQuery('.canvas_div').hide();
  
  doImage(window['topCanvas'],'top');
  doImage(window['sidCanvas'],'sid');
  doImage(window['frtCanvas'],'frt');
  
  fetch('//technology-architects.com/tasweer-modules/save_tissuBox.php',{
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      do_top: window['do_top'],
      do_sid: window['do_sid'],
      do_frt: window['do_frt'],
      temp_top: window['tempBase_top'],
      orig_top: window['origBase_top'],
      temp_sid: window['tempBase_sid'],
      orig_sid: window['origBase_sid'],
      temp_frt: window['tempBase_frt'],
      orig_frt: window['origBase_frt'],
    })
  })
  .then(response => response.json())
  .then(data => {
    var prId = data.id,
        tImg = data.top_url,
        sImg = data.sid_url,
        fImg = data.frt_url;
    console.log(tImg);
    console.log(sImg);
    console.log(fImg);
    
    jQuery('#previewImg').val(prId);

    if(tImg){
      jQuery('.sides_preView').append('<input type="hidden" id="ptExtraImg" name="properties[Top_Image]" value="' + tImg + '">');
    }
    if(sImg){
      jQuery('.sides_preView').append('<input type="hidden" id="psExtraImg" name="properties[Side_Image]" value="' + sImg + '">');
    }
    if(fImg){
      jQuery('.sides_preView').append('<input type="hidden" id="pfExtraImg" name="properties[Front_Image]" value="' + fImg + '">');
    }
    jQuery('.canvas_div').show();
    jQuery('.product-form__buttons .product-form__submit').trigger('click');
    jQuery('#loader').hide();
  })
  .catch(error => console.error('Error uploading images:', error));
});


function removeGuideBoxes() {
  Object.values(window.canvases).forEach(c => {
    const objs = c.getObjects('rect').filter(o => o.name === 'guideBox');
    objs.forEach(o => c.remove(o));
    c.renderAll();
  });
}


function doImage(canvas,id){
  
  removeGuideBoxes();
  
  window['do_'+id] = 0;
  
  if(canvas.getObjects().length > 0){
    sides++;
    window['do_'+id] = 1;
  }

  canvasMakeImg(canvas,temp,id);
  loadWaterMark(canvas,id);
  window['tempBase_'+id] = canvas.toDataURL({
    format: 'png',
    quality: 1.0
  });

  canvasMakeImg(canvas,orig,id);
  removeWaterMark(canvas);
  window['origBase_'+id] = canvas.toDataURL({
    format: 'png',
    quality: 1.0
  });
  canvasBlock(canvas,id);
  console.log(window['do_'+id]);
}

var loadedObject;
function loadWaterMark(canvas,name){
  var elem = document.getElementById(name+'_svg'),
      svgStr = elem.innerHTML;
  removeGuideBoxes();
  fabric.loadSVGFromString(svgStr, function(objects,options){
    const baseWidth = baseDims[name]?.width;
    const baseHeight = baseDims[name]?.height;
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(baseWidth);
    loadedObject.set({
      left: baseWidth / 2,
      top: baseHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.setCoords();
    canvas.renderAll();
  });
}

function removeWaterMark(canvas){
  canvas.remove(loadedObject).renderAll();
}

jQuery(document).on('click','#addDrawing',function(){
  id = jQuery('.side.active').find('.lower-canvas').attr('id');
  canvas = window[id];
  drawingModule(window[id]);
  canvas.set({
    isDrawingMode: true
  }).discardActiveObject().renderAll();
  updateBrush(canvas);
  jQuery('#drawing-mode-options').show();
});

jQuery(document).on('click','#clear-canvas',function(){
  id = jQuery('.side.active').find('.lower-canvas').attr('id');
  canvas = window[id];
  canvas.clear().renderAll();
});

jQuery(document).on('click','#closeDrawing',function(){
  jQuery('.side').each(function(){
    id = jQuery(this).find('.lower-canvas').attr('id');
    canvas = window[id];
    canvas.set({
      isDrawingMode: false
    }).renderAll();
  });
});

function updateBrush(canvas){
  current = jQuery('#drawing-mode-selector').val();
  var select = document.getElementById('drawing-mode-selector');
  var items = select.getElementsByTagName('option');
  var index = Math.floor(Math.random() * items.length);
  select.selectedIndex = index;
  setTimeout(function(){
    jQuery('#drawing-mode-selector').val(current).change();
  },50)
}

function drawingModule(canvas){
  var $ = function(elem){
    return document.getElementById(elem)
  };
  
  fabric.Object.prototype.transparentCorners = false;

  var drawingModeEl = $('drawing-mode'),
      drawingOptionsEl = $('drawing-mode-options'),
      drawingColorEl = $('drawing-color'),
      drawingShadowColorEl = $('drawing-shadow-color'),
      drawingLineWidthEl = $('drawing-line-width'),
      drawingShadowWidth = $('drawing-shadow-width'),
      drawingShadowOffset = $('drawing-shadow-offset'),
      dLW = $('dLW'),
      dSw = $('dSw'),
      dSo = $('dSo');

  drawingModeEl.onclick = function() {
    id = jQuery('.side.active').find('.lower-canvas').attr('id');
    canvas = window[id];
    canvas.isDrawingMode = !canvas.isDrawingMode;
    if (canvas.isDrawingMode) {
      drawingModeEl.innerHTML = 'Cancel drawing mode';
      drawingOptionsEl.style.display = '';
    }
    else {
      drawingModeEl.innerHTML = 'Cancel drawing mode';
      drawingOptionsEl.style.display = 'none';
    }
  };

  if (fabric.PatternBrush) {
    var vLinePatternBrush = new fabric.PatternBrush(canvas);
    vLinePatternBrush.getPatternSrc = function() {

      var patternCanvas = fabric.document.createElement('canvas');
      patternCanvas.width = patternCanvas.height = 10;
      var ctx = patternCanvas.getContext('2d');

      ctx.strokeStyle = this.color;//getAttribute('data-color');
      ctx.lineWidth = 5;
      ctx.beginPath();
      ctx.moveTo(0, 5);
      ctx.lineTo(10, 5);
      ctx.closePath();
      ctx.stroke();

      return patternCanvas;
    };

    var hLinePatternBrush = new fabric.PatternBrush(canvas);
    hLinePatternBrush.getPatternSrc = function() {

      var patternCanvas = fabric.document.createElement('canvas');
      patternCanvas.width = patternCanvas.height = 10;
      var ctx = patternCanvas.getContext('2d');

      ctx.strokeStyle = this.color;//getAttribute('data-color');
      ctx.lineWidth = 5;
      ctx.beginPath();
      ctx.moveTo(5, 0);
      ctx.lineTo(5, 10);
      ctx.closePath();
      ctx.stroke();

      return patternCanvas;
    };

    var squarePatternBrush = new fabric.PatternBrush(canvas);
    squarePatternBrush.getPatternSrc = function() {

      var squareWidth = 10, squareDistance = 2;

      var patternCanvas = fabric.document.createElement('canvas');
      patternCanvas.width = patternCanvas.height = squareWidth + squareDistance;
      var ctx = patternCanvas.getContext('2d');

      ctx.fillStyle = this.color;//getAttribute('data-color');
      ctx.fillRect(0, 0, squareWidth, squareWidth);

      return patternCanvas;
    };

    var diamondPatternBrush = new fabric.PatternBrush(canvas);
    diamondPatternBrush.getPatternSrc = function() {

      var squareWidth = 10, squareDistance = 5;
      var patternCanvas = fabric.document.createElement('canvas');
      var rect = new fabric.Rect({
        width: squareWidth,
        height: squareWidth,
        angle: 45,
        fill: this.color//getAttribute('data-color')
      });

      var canvasWidth = rect.getBoundingRect().width;

      patternCanvas.width = patternCanvas.height = canvasWidth + squareDistance;
      rect.set({ left: canvasWidth / 2, top: canvasWidth / 2 });

      var ctx = patternCanvas.getContext('2d');
      rect.render(ctx);

      return patternCanvas;
    };

    var img = new Image();
    img.src = honeyImg;

    var texturePatternBrush = new fabric.PatternBrush(canvas);
    texturePatternBrush.source = img;
  }
  
  $('drawing-mode-selector').onchange = function(){
    id = jQuery('.side.active').find('.lower-canvas').attr('id');
    canvas = window[id];
    if (this.value === 'hline') {
      canvas.freeDrawingBrush = vLinePatternBrush;
    }
    else if (this.value === 'vline') {
      canvas.freeDrawingBrush = hLinePatternBrush;
    }
    else if (this.value === 'square') {
      canvas.freeDrawingBrush = squarePatternBrush;
    }
    else if (this.value === 'diamond') {
      canvas.freeDrawingBrush = diamondPatternBrush;
    }
    else if (this.value === 'texture') {
      canvas.freeDrawingBrush = texturePatternBrush;
    }
    else {
      canvas.freeDrawingBrush = new fabric[this.value + 'Brush'](canvas);
    }

    if(canvas.freeDrawingBrush){
      var brush = canvas.freeDrawingBrush;
      brush.color = drawingColorEl.getAttribute('data-color');
      if (brush.getPatternSrc) {
        brush.source = brush.getPatternSrc.call(brush);
      }
      brush.width = parseInt(drawingLineWidthEl.value, 10) || 1;
      brush.shadow = new fabric.Shadow({
        blur: parseInt(drawingShadowWidth.value, 10) || 0,
        offsetX: 0,
        offsetY: 0,
        affectStroke: true,
        color: drawingShadowColorEl.getAttribute('data-color'),
      });
    }
  };

  drawingColorEl.onchange = function() {    
    id = jQuery('.side.active').find('.lower-canvas').attr('id');
    canvas = window[id];
    var brush = canvas.freeDrawingBrush;
    brush.color = this.getAttribute('data-color');
    if (brush.getPatternSrc) {
      brush.source = brush.getPatternSrc.call(brush);
    }
  };
  drawingShadowColorEl.onchange = function() {
    id = jQuery('.side.active').find('.lower-canvas').attr('id');
    canvas = window[id];
    canvas.freeDrawingBrush.shadow.color = this.value;
  };
  drawingLineWidthEl.onchange = function() {
    id = jQuery('.side.active').find('.lower-canvas').attr('id');
    canvas = window[id];
    canvas.freeDrawingBrush.width = parseInt(this.value, 10) || 1;
    dLW.innerHTML = this.value;
    updateBrush(canvas);
  };
  drawingShadowWidth.onchange = function() {
    id = jQuery('.side.active').find('.lower-canvas').attr('id');
    canvas = window[id];
    canvas.freeDrawingBrush.shadow.blur = parseInt(this.value, 10) || 0;
    dSw.innerHTML = this.value;
  };
  drawingShadowOffset.onchange = function() {
    id = jQuery('.side.active').find('.lower-canvas').attr('id');
    canvas = window[id];
    canvas.freeDrawingBrush.shadow.offsetX = parseInt(this.value, 10) || 0;
    canvas.freeDrawingBrush.shadow.offsetY = parseInt(this.value, 10) || 0;
    dSo.innerHTML = this.value;
  };
  
  if (canvas.freeDrawingBrush) {
    canvas.freeDrawingBrush.color = drawingColorEl.getAttribute('data-color');
    //canvas.freeDrawingBrush.source = canvas.freeDrawingBrush.getPatternSrc.call(this);
    canvas.freeDrawingBrush.width = parseInt(drawingLineWidthEl.value, 10) || 1;
    canvas.freeDrawingBrush.shadow = new fabric.Shadow({
      blur: parseInt(drawingShadowWidth.value, 10) || 0,
      offsetX: 0,
      offsetY: 0,
      affectStroke: true,
      color: drawingShadowColorEl.getAttribute('data-color')//.value,
    });
  }
};

(function() {
  // manually initialize 2 filter backend to give ability to switch:
  var webglBackend;
  try {
    webglBackend = new fabric.WebglFilterBackend();
  } catch (e) {
    console.log(e)
  }
  var canvas2dBackend = new fabric.Canvas2dFilterBackend();

  fabric.filterBackend = fabric.initFilterBackend();
  fabric.Object.prototype.transparentCorners = false;
  var $ = function(id){return document.getElementById(id)};

  function applyFilter(index, filter) {
    var obj = canvas.getActiveObject();
    obj.filters[index] = filter;
    obj.applyFilters();
    canvas.renderAll();
    drawHistory.updateCanvasState(canvas,id);
  }

  function getFilter(index) {
    var obj = canvas.getActiveObject();
    return obj.filters[index];
  }

  function applyFilterValue(index, prop, value) {
    var obj = canvas.getActiveObject();
    if (obj.filters[index]) {
      obj.filters[index][prop] = value;
      obj.applyFilters();
      canvas.renderAll();
    }
  }
  
  var indexF;
  $('grayscale').onclick = function() {
    applyFilter(0, this.checked && new f.Grayscale());
  };
  $('average').onclick = function() {
    applyFilterValue(0, 'mode', 'average');
  };
  $('luminosity').onclick = function() {
    applyFilterValue(0, 'mode', 'luminosity');
  };
  $('lightness').onclick = function() {
    applyFilterValue(0, 'mode', 'lightness');
  };
  $('invert').onclick = function() {
    applyFilter(1, this.checked && new f.Invert());
  };
  $('remove-color').onclick = function () {
    applyFilter(2, this.checked && new f.RemoveColor({
      distance: $('remove-color-distance').value,
      color: $('remove-color-color').value,
    }));
  };
  $('remove-color-color').onchange = function() {
    applyFilterValue(2, 'color', this.value);
  };
  $('remove-color-distance').oninput = function() {
    applyFilterValue(2, 'distance', this.value);
  };
  $('sepia').onclick = function() {
    applyFilter(3, this.checked && new f.Sepia());
  };
  $('brownie').onclick = function() {
    applyFilter(4, this.checked && new f.Brownie());
  };
  $('brightness').onclick = function () {
    applyFilter(5, this.checked && new f.Brightness({
      brightness: parseFloat($('brightness-value').value)
    }));
  };
  $('brightness-value').oninput = function() {
    applyFilterValue(5, 'brightness', parseFloat(this.value));
  };
  $('vintage').onclick = function() {
    applyFilter(7, this.checked && new f.Vintage());
  };
  $('technicolor').onclick = function() {
    applyFilter(8, this.checked && new f.Technicolor());
  };
  $('polaroid').onclick = function() {
    applyFilter(9, this.checked && new f.Polaroid());
  };
  $('kodachrome').onclick = function() {
    applyFilter(10, this.checked && new f.Kodachrome());
  };
  $('blackwhite').onclick = function() {
    applyFilter(11, this.checked && new f.BlackWhite());
  };
})();